// L&TT home link route only
export const baseUrl = "https://atci.lkm.accenture.com/lttmicrosite-apis";

export const BASE_API_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:1111"
    : "https://atcgn.lkm.accenture.com/atcgn-api";
